import React from "react";
import {
  Button,
  CkTextEditor,
  Divider,
  InfoTextAdv,
} from "../../../../../../../components";

const TemplatePreviewModel = ({
  stepId,
  availableTemplates,
  //campaignType,
  clickedView,
  onUseTemplate,
  //onClose,
}) => {
  const editorContent = `
    <p>David J. Mosure, PE</p>
    <p>Vice president, ms consultants, inc.</p>
    <p>Mr. Mosure is a professional engineer since 1983 with 38 years of experience.</p>
  `;

  const handleUseTemplate = (templateValue) => {
    onUseTemplate(templateValue, stepId);
  };

  // Find the clicked template to display
  const templateToShow = availableTemplates.find(
    (template) => template.value === clickedView
  );

  if (!templateToShow) {
    return (
      <div className="text-center text-gray-500 py-8">Template not found</div>
    );
  }

  return (
    <div className="flex flex-col gap-3 p-2">
      <div className="rounded-md shadow-md bg-primary-50/40 p-3 flex flex-col gap-3">
        <div className="flex justify-between items-center">
          <span className="text-sm text-primary font-medium">
            {templateToShow.label}
          </span>
          <Button
            title={"Use this template"}
            onClick={() => handleUseTemplate(templateToShow.value)}
          />
        </div>

        <div className="bg-white rounded-lg p-3 border-2 border-gray-100 flex justify-around gap-3">
          <InfoTextAdv
            title={"Created By"}
            size="sm"
            titleProps={{ className: "!text-black" }}
            value={<h6 className="line-clamp-1 text-black">Chandan T.</h6>}
          />
          <Divider orientation="vertical" />
          <InfoTextAdv
            title={"Created On"}
            titleProps={{ className: "!text-black" }}
            size="sm"
            value={<h6 className="line-clamp-1 text-black">Oct 15, 2015</h6>}
          />
          <Divider orientation="vertical" />
          <InfoTextAdv
            title={"Location"}
            size="sm"
            titleProps={{ className: "!text-black" }}
            value={<h6 className="line-clamp-1 text-black">India</h6>}
          />
        </div>

        <div className="flex p-2 rounded border-1 border-gray-200 text-sm">
          <span className="font-medium me-2">Subject:</span>
          <span>
            Opportunity for Candidates for new job - {templateToShow.label}
          </span>
        </div>

        <CkTextEditor value={editorContent} height="500px" className="mb-4" />
      </div>
    </div>
  );
};

export default TemplatePreviewModel;
